import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { corHGlobal } from '../servicio/config/config.module';
import { Login } from '../Models/login-dto';
import { Subject, Observable } from 'rxjs';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
@Injectable({
  providedIn: 'root'
})
export class ServiceLogin {

  private actionUrl: string;
  private corsHeadersLocal: HttpHeaders;
  private corsHeadersLocalG: HttpHeaders;

  private userLoggedIn = new Subject<boolean>();

  constructor(private corhglobal: corHGlobal, private http: HttpClient, @Inject(LOCAL_STORAGE) private storage: WebStorageService) {
    this.actionUrl = environment.ROOT_URL + '/';
    this.corhglobal.cambioToken(this.storage.get("TOKEN"));
    this.corsHeadersLocal = corhglobal.CORSHEADERS;
    this.userLoggedIn.next(false);
  }
  public getLoginReset(usr: Login) {
    var login = {
      Ruc: usr.Ruc,
      Usuario: usr.Usuario,
      Clave: usr.Clave
    }
    return this.http.post<Login>(this.actionUrl + 'ResetClave', login, { headers: this.corsHeadersLocal });

  }
  public getLoginResetAdmin(usr: Login) {
    var login = {
      Ruc: usr.Ruc,
      Usuario: usr.Usuario,
      Clave: usr.Clave
    }
    return this.http.post<Login>(this.actionUrl + 'ResetClaveAdmin', login, { headers: this.corsHeadersLocal });

  }
  public getLogin(usr: Login) {
    var login = {
      Ruc: usr.Ruc,
      Usuario: usr.Usuario,
      Clave: usr.Clave
    }
    return this.http.post<Login>(this.actionUrl + 'SessionUsuario', login, { headers: this.corsHeadersLocal });

  }

  public getLoginPerfil(usr: Login) {
    var login = {
      Ruc: usr.Ruc,
      Usuario: usr.Usuario,
      Clave: usr.Clave,
      CodPorv: usr.CodPorv
    }
    return this.http.post<Login>(this.actionUrl + 'InicioSessionPerfil', login, { headers: this.corsHeadersLocal });
  }

  public getLoginPerfilAdmin(usr: Login) {
    var login = {
      Usuario: usr.Usuario,
      Clave: usr.Clave,
      CodPorv: usr.CodPorv
    }
    return this.http.post<Login>(this.actionUrl + 'InicioSessionPerfilAdmin', login, { headers: this.corsHeadersLocal });

  }
  public getLoginAdmin(usr: Login) {
    var login = {
      Usuario: usr.Usuario,
      Clave: usr.Clave
    }
    return this.http.post<Login>(this.actionUrl + 'SessionUsuarioAdmin', login, { headers: this.corsHeadersLocal });

  }

  public setUsuarioLoginIn(userLoggedIn: boolean) {
    this.userLoggedIn.next(userLoggedIn);
  }

  public getUsuarioLoginIn(): Observable<boolean> {
    return this.userLoggedIn.asObservable();
  }
}

